import { Map } from "immutable";

import TeacherAssignment from "../../models/TeacherAssignment";
import TeacherAssignmentsState from "../../models/TeacherAssignmentsState";
import TeacherAssignmentsMetaState from "../../models/TeacherAssignmentsMetaState";

export function getAssignments(
  state: TeacherAssignmentsState
): Map<string, TeacherAssignment> {
  return state.assignments;
}

export function getMeta(
  state: TeacherAssignmentsState
): TeacherAssignmentsMetaState {
  return state.meta;
}
